import React from "react";

/**
 * Renders a chemical formula string with subscripted numbers.
 * E.g. "C10H14" → C₁₀H₁₄
 */
export function renderFormula(formula: string): React.ReactNode {
  if (!formula) return "—";
  const parts = formula.split(/(\d+)/);
  return (
    <>
      {parts.map((part, i) =>
        /^\d+$/.test(part) ? <sub key={i}>{part}</sub> : part
      )}
    </>
  );
}
